import type { CSSProperties, ReactNode } from 'react';
import classes from './FactsStrip.module.css';

/** Ячейка полосы фактов. */
export interface Fact {
  readonly key: string;
  readonly label: string;
  readonly value: ReactNode;
  /** Пояснение мелким текстом под значением (полный адрес под названием базиса). */
  readonly note?: ReactNode;
  /** Широкая ячейка: вдвое шире остальных, на телефоне — во всю строку. */
  readonly wide?: boolean;
}

// Полоса фактов «Бюллетеня» (образец b-deal): подписанные значения в одну строку, на телефоне — в две колонки.
// Пустые ячейки вызывающий не передаёт: «—» в полосе фактов ничего не сообщает.
export default function FactsStrip({ facts }: { readonly facts: readonly Fact[] }) {
  if (facts.length === 0) {
    return null;
  }
  const columns = facts.map((fact) => (fact.wide ? 'minmax(0, 2fr)' : 'minmax(0, 1fr)')).join(' ');
  return (
    <dl className={classes.facts} style={{ '--facts-columns': columns } as CSSProperties}>
      {facts.map((fact) => (
        <div key={fact.key} className={fact.wide ? `${classes.fact} ${classes.wide}` : classes.fact}>
          <dt>{fact.label}</dt>
          <dd>
            {fact.value}
            {fact.note ? <span className={classes.note}>{fact.note}</span> : null}
          </dd>
        </div>
      ))}
    </dl>
  );
}
